export const REVIEWEE_FILTER_QUERY_KEYS = ["managerIds", "segmentIds", "reportingLineIds", "departments", "genders", "workLocations", "jobLevels", "jobTitles", "tenure", "track"] as const;
